// extracted by mini-css-extract-plugin
export default {"activityValue":"ActivityDetail_activityValue__L3nEa"};